import React, { useState } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import colors from 'theme/colors'
import fonts from 'theme/fonts'
import sizes from 'theme/sizes'

export default function TextArea({
    name,
    register,
    validations,
    squired = false,
    marginTop,
    value,
    label = false,
    placeholder = '',
    onChangeValue = () => false,
    ...props
}) {
    const [newValue, setNewValue] = useState(value);

    const toggleValue = (e) => {
        setNewValue(e);
        onChangeValue(e);
    };

    return (
        register ? (
            <Column>
                {
                    label && (
                        <StyledLabel>
                            {label}
                        </StyledLabel>
                    )
                }
                <StyledTextArea
                    squired={squired}
                    {...props}
                    placeholder={placeholder}
                    {...register(name, validations)}
                    marginTop={marginTop}
                    onChange={(e) => toggleValue(e.target.value)}
                />
            </Column>
        ) : (
            <Column>
                {
                    label && (
                        <StyledLabel>
                            {label}
                        </StyledLabel>
                    )
                }
                <StyledTextArea
                    squired={squired}
                    placeholder={placeholder}
                    {...props}
                    onChange={(e) => toggleValue(e.target.value)}
                    marginTop={marginTop}
                />
            </Column>
        )

    )
}


const StyledTextArea = styled.textarea`
    width: 100%;
    resize: none;
    border: 1.5px solid ${colors.night}22;
    border-radius: 10px;
    padding: ${sizes.normal} ${sizes.mini};
    font-weight: ${fonts.weight.bold};
    background: transparent;
    color: ${colors.night};
    outline: none;

    ${({ marginTop }) => marginTop && `
        margin-top: ${marginTop};
    `};
    
    ${({ squired }) => squired && `
        border: 1.5px solid ${colors.night}22;
        border-radius: 10px !important;

        &:focus {
            border: 1.5px solid ${colors.occasionalPurple} !important;
        }
    `};

    &:focus {
        border: 1.5px solid ${colors.occasionalPurple};
    }


    &::placeholder {
        color: ${colors.nightLight};
        font-weight: ${fonts.weight.regular};
    }
`

const StyledLabel = styled.label`
    color: ${colors.nightDark};
    font-size: ${fonts.sizes.small};
    font-weight: 600;
    text-align: left;
`;
